import { supabase } from './supabaseClient';
import { readStoredErpSession } from './erpSessionStorage';

export const getSession = async () => {
  return readStoredErpSession();
};

export const testConnection = async () => {
  try {
    const session = readStoredErpSession();
    if (!session?.session_token) return true;

    const { error } = await supabase.rpc('erp_whoami');
    if (error && !['42883', 'PGRST202'].includes(error.code || '')) {
      throw error;
    }

    console.log('Supabase ERP connection OK');
    return true;
  } catch (error) {
    console.error('Supabase ERP baglanti hatasi:', error?.message || error);
    return false;
  }
};
